<template>
  <v-stepper-content step="3">
    <v-row justify="center">
      <p class="headline">
        Registration QR code
      </p>
    </v-row>
    <v-row justify="center" width="400">
      <p class="textfield">
        When the LiveSYNC app running on your device wants to read a registration QR code,
        show this one-time code to its back camera.
        Proper reading distance is 10-15 cm from the camera.
        If you are unable to read the QR code, try increasing display brightness.
        As an alternative, you can type the textual code manually into the app.
      </p>
    </v-row>
    <v-row justify="center">
      <canvas
        ref="myCanvas"
        id="myCanvas"
        width="400"
        height="400"
      ></canvas>
    </v-row>
    <v-row justify="center">
      <p>
        {{deviceRegistrationCode}}
      </p>
    </v-row>
    <v-row justify="end">
      <v-btn class="ma-3" rounded @click="$emit('update:e1', 2)">Back</v-btn>
      <v-btn
        class="ma-3"
        color="primary"
        @click="$emit('update:e1', 4)"
        rounded
      >
        Next
      </v-btn>
    </v-row>
  </v-stepper-content>
</template>
<script>
import QRCode from 'qrcode';
import EventBus from '@/utils/EventBus';
import gql from 'graphql-tag';

const ADD_DEVICE = gql`
  mutation addDevices ($deviceRegistrationCode: String!, $type: String!) {
    insert_devices_one(object: {
      code: $deviceRegistrationCode
      type: $type
    }) {
      id
      code
      serial
      firmware
      name
      description
      user_id
    }
  }
`;

export default {
  props: {
    type: {
      type: String,
      required: true,
    },
  },
  data() {
    return {
      deviceRegistrationCode: null,
      cameraId: null,
    };
  },
  created() {
    EventBus.$on('device-registration-code-created', this.deviceRegistrationCodeCreatedHandler);
    EventBus.$on('device-registered', this.deviceRegisteredHandler);
  },
  beforeDestroy() {
    EventBus.$off('device-registration-code-created', this.deviceRegistrationCodeCreatedHandler);
    EventBus.$off('device-registered', this.deviceRegisteredHandler);
  },
  computed: {
    cameraModel() {
      return this.$store.state.cameraModel;
    },
  },
  methods: {
    deviceRegistrationCodeCreatedHandler(code) {
      this.deviceRegistrationCode = code;
      this.addDevice();
    },
    deviceRegisteredHandler(device) {
      if (device.id === this.cameraId && device.code === null) {
        this.$store.commit('cameraId', device.id);
        this.$store.commit('cameraFirmware', device.firmware);
        this.$store.commit('cameraSerial', device.serial);
        this.$emit('update:e1', 4);
      }
    },
    addDevice() {
      const { deviceRegistrationCode, type } = this;
      this.$apollo.mutate({
        mutation: ADD_DEVICE,
        variables: {
          deviceRegistrationCode,
          type,
        },
        // eslint-disable-next-line
        update: (cache, { data: { insert_devices_one } }) => {
          // Read the data from our cache for this query.
          // eslint-disable-next-line
          // TODO: error handling what if mutation doesn't work
          this.cameraId = insert_devices_one.id;
          this.convert();
        },
      });
    },
    convert() {
      QRCode.toCanvas(
        this.$refs.myCanvas,
        this.deviceRegistrationCode,
        { width: 400, height: 400 },
        (error) => {
          if (error) console.error(error);
        },
      );
    },
  },
};
</script>

<style scoped>
#myCanvas {
  width: 400px;
  height: 400px;
}

.textfield {
  max-width: 400px;
  overflow: hidden;
  word-wrap: break-word;
}
</style>
